module.exports = __webpack_public_path__ + "media/dashboard/assets/images/video-fa1c94a8bac936c898f398817cec3e3d.svg";